import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=78d0cc6c&"
import script from "@/scripts/Coupon/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Coupon/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports